export const COMPANIES = [
  'Google',
  'Amazon',
  'Microsoft',
  'Meta',
  'Flipkart',
  'Atlassian',
  'Uber',
  'Adobe',
];
